const buildAutomaticNotificationRows = (
  preferences,
  events,
  resolveIcon,
  automaticPreferenceKeyFor,
  hasOrganizationTab,
) =>
  events.map((event) => {
    const preferenceKey = automaticPreferenceKeyFor(event.id)
    const cells = {
      mine: { checked: preferences.mine[preferenceKey] ?? true },
    }
    if (hasOrganizationTab) {
      cells.company = { checked: preferences.company[preferenceKey] ?? true }
    }

    return {
      id: event.id,
      icon: resolveIcon(event),
      title: event.title,
      subtitle: event.subtitle,
      cells,
    }
  })

export default buildAutomaticNotificationRows
